import { createApi } from "@reduxjs/toolkit/query/react";
import { buildBaseQuery } from "@app/api";
import { FilterParams } from "types";

import { IIngredient, IngredientCreationPayload } from "../types/index";

export const ingredientApi = createApi({
  reducerPath: "ingredientApi",
  baseQuery: buildBaseQuery(""),
  endpoints: (builder) => ({
    getIngredients: builder.query<{ ingredients: IIngredient[]; count: number}, FilterParams>({
      query: (params) => {
        const queryString = Object.entries(params)
          .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
          .join('&');

        return `/ingredients/dashboard?${queryString}`;
      },
    }),
    getIngredientById: builder.query<IIngredient, string>({
      query: (ingredietId) => `/ingredients/${ingredietId}`,
    }),
    createIngredient: builder.mutation<void, IngredientCreationPayload>({
      query: (body) => ({
        url: "/ingredients",
        method: "POST",
        body,
      }),
    }),
    updateIngredient: builder.mutation<void, {id: string; body: IngredientCreationPayload}>({
      query: ({ id, body }) => ({
        url: `/ingredients/${id}`,
        method: "PATCH",
        body,
      }),
    }),
    updateIngredientConfiguration: builder.mutation<void, {
      id: string;
      body: {
        bestSeller?: boolean;
        activeInHome?: boolean;
      };
    }>({
      query: ({ id, body }) => ({
        url: `/ingredients/${id}/config`,
        method: "PATCH",
        body,
      }),
    }),
    deleteIngredient: builder.mutation<void, { id: string }>({
      query: ({ id }) => ({
        url: `/ingredients/${id}`,
        method: "DELETE",
      }),
    }),
  }),
});

export const {
  useGetIngredientsQuery,
  useLazyGetIngredientsQuery,
  useDeleteIngredientMutation,
  useCreateIngredientMutation,
  useUpdateIngredientMutation,
  useUpdateIngredientConfigurationMutation,
  useLazyGetIngredientByIdQuery,
} = ingredientApi;
